import { render, staticRenderFns } from "./CookieManagementToggle.vue?vue&type=template&id=508a7e9a"
import script from "./CookieManagementToggle.vue?vue&type=script&lang=js"
export * from "./CookieManagementToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports